import { render, staticRenderFns } from "./Estrutura.vue?vue&type=template&id=cb4dd298&scoped=true&lang=pug"
import script from "./Estrutura.vue?vue&type=script&lang=js"
export * from "./Estrutura.vue?vue&type=script&lang=js"
import style0 from "./Estrutura.styl?vue&type=style&index=0&id=cb4dd298&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4dd298",
  null
  
)

export default component.exports